import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";


export class ProgramVehiclesByDistanceUnitTableRowCtrl implements IController {

  // vehicleData: any;
  // isEdit: any;
  // index: number;
  // vehicleOptions: any;
  // excludeOriginIds: any;
  // onVehicleChanged: Function;
  // onChange: Function;
  // onDelete: Function;
  //
  // $onChanges(onChangesObj: angular.IOnChangesObject) {
  // }
  //
  // onValueChanged({value, index}) {
  //   this.vehicleData.data.vehiclePriceData[0].value = value;
  //   this.onChange({index: index, vehicleData: this.vehicleData})
  // }

  tier: any;
  isEdit: boolean;
  isFirst:boolean;
  isLast: boolean;
  min: any;
  max: any;
  onUpdateTier: Function;
  onDelete: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.isLast || changes.min) {
      if (this.isLast) {
        this.distanceChanged(_.isNumber(this.min) ? this.min : 0, 'from')
      }
    }
  };

  updateRequired() {
    this.onUpdateTier({tier: this.tier});
  }

  distanceChanged(value, path) {
    this.tier[path] = angular.copy(value);
    this.updateRequired();
  }

  extraChargeChanged(value){
    this.tier.extraChargePerMeter = value;
    this.updateRequired();
  }


}

angular
  .module('bringoz.admin.pricePlan')
  .component('programVehiclesByDistanceUnitTableRow', {
    require: {
      form: '^form'
    },
    bindings: {
      index: '<',
      tier: '<',
      isEdit: '<?',
      isFirst: '<?',
      isLast: '<?',
      min: '<?',
      max: '<?',
      onUpdateTier: '&',
      onDelete: '&'
    },
    template: require('./program-vehicles-by-distance-unit-table-row.html').default,
    controller: ProgramVehiclesByDistanceUnitTableRowCtrl
  });
